import * as React from "react";
import {
  SettingsAutocomplete,
  SettingsAutoCompleteOption,
} from "./settingsAutocomplete";
import { useEffect, useState } from "react";
import { useClinicContext } from "../../../clinic/ClinicContext";
import { MASTER_CLINIC_ID } from "fe-common/commonTypes/masterClinicDefaults";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicSelectorProps {
  onSelect: (value: any) => void;
  value: string;
  disableAutoFocus?: boolean;
  disabled?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicSelector = ({ ...props }: ClinicSelectorProps) => {
  const [clinicList, setClinicList] = useState<SettingsAutoCompleteOption[]>(
    null,
  );
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState<SettingsAutoCompleteOption>(null);
  const dao = useClinicContext();

  const getClinics = async () => {
    setLoading(true);
    const data = await dao.userClinics(false).then((response) =>
      response.map((c) => ({
        name:
          c.id === MASTER_CLINIC_ID ? `* ${c.displayName} *` : c.displayName,
        value: c.id,
      })),
    );
    //move master clinic to start
    const orderedData = [
      data.find((c) => c.value === MASTER_CLINIC_ID),
      ...data.filter((c) => c.value !== MASTER_CLINIC_ID),
    ];
    setClinicList(orderedData);
    setLoading(false);
  };

  const handleSelect = (newValue: SettingsAutoCompleteOption) => {
    setValue(newValue);
    props.onSelect(newValue?.value);
  };

  useEffect(() => {
    if (!clinicList) {
      getClinics().catch((e) => console.error(e.error));
    }

    if (clinicList && props.value && props.value !== value?.value) {
      setValue(
        {
          value: props.value,
          name: clinicList.find((c) => c.value === props.value)?.name,
        } || null,
      );
    }
  }, [clinicList, props.value]);

  return (
    <SettingsAutocomplete
      onChange={(selValue) => handleSelect(selValue)}
      value={value}
      loading={loading}
      options={clinicList || []}
      autoFocus={!props.disableAutoFocus}
      disabled={props.disabled}
    />
  );
};
